import { render, staticRenderFns } from "./Img.vue?vue&type=template&id=607d6d95&scoped=true&lang=html&"
import script from "./Img.vue?vue&type=script&lang=js&"
export * from "./Img.vue?vue&type=script&lang=js&"
import style0 from "./Img.vue?vue&type=style&index=0&id=607d6d95&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607d6d95",
  null
  
)

export default component.exports